import { connect } from "react-redux"
import React from "react";
import { Drawer, Icon, Card, notification, Input, Button, Row, Col, Popover, Checkbox } from "antd";
import _ from 'lodash';
import Request from "../../request";
import moment from "moment";
import { RightsWrapper } from "../_utils/utils";
let companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {};
let dateFormat = companyDetails && companyDetails.dateFormat ? companyDetails.dateFormat : 'DD.MM.YYYY';
let companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

class GroupedPerformaInvoice extends React.Component {
    state = {
        visible: true,
        generatedInvoice: {},
        hasConversionRate: false,
        showInvoiceNumber: false,
        showInvoiceDate: false,
        companyDetails: [],
        allTaxes: [],
        cpTaxTypeId: '',
        taxPercentange: 0,
        enableBTN: false,
        taxPaidBy: null,
    };

    loadInvoiceDetail = async () => {
        let { invoiceIds } = this.props;
        let ids = [];
        _.each(invoiceIds.usersData, (id) => {
            ids.push(id._id.toString());
        })
        const res = await Request.getInvoiceDetails({ ids });
        if (!res.error) {
            this.setState({ generatedInvoice: res.data });
        }
    }

    constructor(props) {
        super(props);
        this.tableScrollRef = React.createRef();
    }

    loadCompanyBankDetails = async () => {
        let response = await Request.getCompanyBankDetails();
        if (!response.error) {
            this.setState({ companyDetails: response.results });
        } else {
            notification.error({
                message: 'Error generating invoice'
            })
        }
    }

    getAllTaxes = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        let data = await Request.getTaxDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allTaxes: data.data });
    }

    getAllInvoiceToDetails = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        params.sortField = 'invoiceToName'
        params.sortOrder = 'ascend'
        let data = await Request.getInvoiceToDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allInvoiceToDetails: data.data });
    }
    loadCountry() {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
            businessId: activeUser && activeUser.businessId,
        };
        Request.getCountriesWithoutAuth(params)
            .then((resp) => {
                if (resp) {
                    let temp = [];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id,
                        });
                    });
                    this.setState({ countryArr: temp });
                }
            })
            .catch((err) => {
            });
    }
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ 'universities': resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadChannelPartner = async () => {
        Request.loadChannelPartners({
            results: 10000,
            count: 1000
        })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.channelPartnerName })
                    return temp
                }, [])

                this.setState({ 'channelPartners': resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }


    removeUserFromInvoice = (invoice) => {
        let generatedInvoice = this.state.generatedInvoice;
        generatedInvoice.invoices = generatedInvoice.invoices.filter((item) => item.studentId !== invoice.studentId)
        this.setState({ generatedInvoice })
    }


    componentDidMount() {
        this.loadInvoiceDetail()
        this.loadCompanyBankDetails();
        this.getAllTaxes();
        this.getAllInvoiceToDetails();
        this.loadCountry();
        this.loadUniversity();
        this.loadChannelPartner();

    }


    doSubmitCompanyBankId = async (e) => {
        const { invoiceId } = this.props;
        const { generatedInvoice, showInvoiceDate, hasConversionRate, additionalDeduction, hasBankCharges } = this.state;
        if (!generatedInvoice.invoiceGeneratedDate && showInvoiceDate) {
            return notification.error({
                message: 'Invoice Date Is Required!'
            })
        }
        if (!generatedInvoice.companyBankId) {
            return notification.error({
                message: 'Company Is Required!'
            })
        }
        if (generatedInvoice.taxPaidBy == 'University' && !generatedInvoice.taxTypeId) {
            return notification.error({
                message: 'Tax Is Required!'
            })
        }
        generatedInvoice.hasConversionRate = hasConversionRate;
        generatedInvoice.additionalDeduction = additionalDeduction;
        generatedInvoice.hasBankCharges = hasBankCharges;
        this.setState({ enableBTN: true })
        let response = await Request.financeGenerateGroupInvoice(generatedInvoice)
        this.setState({ enableBTN: false })
        if (response.success) {
            notification.success({
                message: response.msg
            })
        } else {
            notification.error({
                message: response.msg
            })
        }

        this.onClose();

    }

    updateCpTax = async (e) => {
        let { hasConversionRate, generatedInvoice } = this.state;
        if (hasConversionRate == true) {
            if (e === "") {
                generatedInvoice.taxTypeId = ""
                this.setState({ cpTaxTypeId: e, taxPercentange: 0, generatedInvoice })
            }
            let response = await Request.financeTaxDetailsByID({ id: e })
            let { taxTypeArray } = response.doc
            let totalTaxPercentage = 0
            _.each(taxTypeArray, (tax) => {
                totalTaxPercentage += parseFloat(tax.taxValue)
            })
            generatedInvoice.taxTypeId = e;
            this.setState({ cpTaxTypeId: e, taxPercentange: totalTaxPercentage, generatedInvoice })
        } else {
            generatedInvoice.taxTypeId = e;
            this.setState({ generatedInvoice })
        }
    }

    updateAdditionalCpTax = async (e) => {
        let { hasConversionRate, generatedInvoice, additionalDeduction } = this.state;
        if (additionalDeduction && hasConversionRate) {
            if (e === "") {
                generatedInvoice.additionalTaxTypeId = ""
                this.setState({ additionalTaxTypeId: e, additionalTaxPercentange: 0, generatedInvoice })
            }
            let response = await Request.financeTaxDetailsByID({ id: e });
            let { taxTypeArray } = response.doc
            let totalTaxPercentage = 0
            _.each(taxTypeArray, (tax) => {
                totalTaxPercentage += parseFloat(tax.taxValue)
            })
            generatedInvoice.additionalTaxTypeId = e;
            generatedInvoice.additionalTaxName = response.doc.taxTitle;
            this.setState({ additionalTaxTypeId: e, additionalTaxPercentange: totalTaxPercentage, generatedInvoice, additionalTaxName: response.doc.taxTitle })
        } else {
            generatedInvoice.additionalTaxTypeId = e;
            this.setState({ generatedInvoice })
        }
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    render() {
        let { generatedInvoice, showInvoiceNumber, showInvoiceDate, companyDetails, allTaxes, taxPercentange, enableBTN } = this.state;
        let invoiceReceivingDate = generatedInvoice.invoiceGeneratedDate ? moment(generatedInvoice.invoiceGeneratedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        let content = <p style={{ color: '#1890FF' }}>Since you have received the funds in your local currency, please apply the appropriate exchange rate to reconcile the amount accordingly.<br />
            Kindly refer to the table above and update the required details in the editable sections.</p>
        let invoiceCurrency = generatedInvoice && generatedInvoice.invoices && generatedInvoice.invoices.length > 0 ? generatedInvoice.invoices[0].currency : null;
        return (
            <Drawer
                title="Generate Invoice"
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    {/* <Row>
                        <Col span={12}>
                            <Checkbox
                                checked={this.state.hasConversionRate}
                                onChange={(y) => {
                                    this.setState({ hasConversionRate: y.target.checked })
                                }}
                            >Have Conversion Rate <Popover placement='bottomLeft' content={content}>?</Popover>
                            </Checkbox>
                        </Col>
                    </Row> */}
                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>
                            <div className='ant-table-scroll scrolling-table' style={{ overflow: 'auto' }} ref={this.tableScrollRef}>
                                <table className='ant-table-fixed' >
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Student ID</th>
                                            <th className='ant-table-row-cell-break-word'>Student Name</th>
                                            <th className='ant-table-row-cell-break-word'>Date Of Birth</th>
                                            <th className='ant-table-row-cell-break-word'>Course</th>
                                            <th className='ant-table-row-cell-break-word'>Course Start Date</th>
                                            <th className='ant-table-row-cell-break-word'>Tuition Fee Paid ({invoiceCurrency})</th>
                                            <th className='ant-table-row-cell-break-word'>Commission Percentage</th>
                                            <th className='ant-table-row-cell-break-word'>Commission Amount ({invoiceCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Conversion Rate ({companyCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Net Amount ({companyCurrency})</th>
                                            {/* <th className="ant-table-row-cell-break-word" hidden={this.state.bankCharges ? false : true}>Bank Charges</th> */}
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Tax Amount ({companyCurrency})</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Round-Off ({companyCurrency})</th>
                                            {/* <th className='ant-table-row-cell-break-word' hidden={this.state.additionalDeduction ? false : true}>{this.state.additionalTaxName ? this.state.additionalTaxName : 'Additional Deduction'}</th> */}
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>Gross Amount ({companyCurrency})</th>

                                            <th className='ant-table-row-cell-break-word'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody'>
                                        {generatedInvoice.invoices && generatedInvoice.invoices.map((invoice, index) => {
                                            let selectedStudent = invoice.inquiry
                                            return (
                                                <tr key={index}>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk && selectedStudent.visaDesk.selectedCourse && selectedStudent.visaDesk.selectedCourse.instituteStudentId ? selectedStudent.visaDesk.selectedCourse.instituteStudentId : selectedStudent.instituteStudentId ? selectedStudent.instituteStudentId : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.studentName}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.dateOfBirth ? moment(selectedStudent.dateOfBirth).format(dateFormat) : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.courseName : ''}{selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.campusName ? `(${selectedStudent.visaDesk.selectedCourse.campusName})` : '' : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>{selectedStudent.visaDesk ? moment(selectedStudent.visaDesk.courseStartDate).format(dateFormat) : ''}</td>
                                                    <td className='ant-table-row-cell-break-word'>
                                                        <Input
                                                            type='text'
                                                            value={invoice.tutionFee}
                                                            onChange={(e) => {
                                                                generatedInvoice.invoices[index].tutionFee = e.target.value
                                                                this.setState({ generatedInvoice })
                                                            }}
                                                        />
                                                    </td>
                                                    <td className='ant-table-row-cell-break-word'>
                                                        <Input
                                                            type='text'
                                                            value={invoice.commissionFromCourse}
                                                            onChange={(e) => {
                                                                generatedInvoice.invoices[index].commissionFromCourse = e.target.value
                                                                this.setState({ generatedInvoice })
                                                            }}
                                                        />
                                                    </td>
                                                    <td className='ant-table-row-cell-break-word'>{invoice.commissionTypeFrom == 'Percentage' ? (parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100).toFixed(2) : (invoice.commissionFromCourse ? parseFloat(invoice.commissionFromCourse).toFixed(2) : '')}</td>
                                                    <td className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>
                                                        <Input
                                                            type='text'
                                                            value={invoice.conversionRate}
                                                            onChange={(e) => {
                                                                generatedInvoice.invoices[index].conversionRate = e.target.value;

                                                                this.setState({ generatedInvoice });
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="ant-table-row-cell-break-word" hidden={!this.state.hasConversionRate}>
                                                        {
                                                            (() => {

                                                                const commissionFromCourse = parseFloat(invoice.commissionFromCourse || 0);
                                                                const tutionFee = parseFloat(invoice.tutionFee || 0);
                                                                const conversionRate = parseFloat(invoice.conversionRate || 0);
                                                                const taxPercent = parseFloat(this.state.taxPercentange || 0);
                                                                const taxPaidBy = this.state.taxPaidBy;

                                                                let total = 0;

                                                                if (invoice.commissionTypeFrom === 'Percentage') {
                                                                    total = (commissionFromCourse * tutionFee / 100) * conversionRate;
                                                                } else if (commissionFromCourse && conversionRate) {
                                                                    total = commissionFromCourse * conversionRate;
                                                                }

                                                                // Deduct tax portion if taxPercent is greater than 0
                                                                if (taxPercent > 0) {
                                                                    if (taxPaidBy === "Company") {
                                                                        total = total * 100 / (100 + taxPercent);
                                                                    }

                                                                }

                                                                return total.toFixed(2);
                                                            })()
                                                        }
                                                    </td>
                                                    {/* Bank Charges If Any */}
                                                    {/* <td className="ant-table-row-cell-break-word" hidden={!this.state.bankCharges}>
                                                        <Input
                                                            type='text'
                                                            value={invoice.bankCharges ? invoice.bankCharges : ""}
                                                            onChange={(e) => {
                                                                generatedInvoice.invoices[index].bankCharges = e.target.value;
                                                                this.setState({ generatedInvoice });
                                                            }}
                                                        />
                                                    </td> */}
                                                    <td
                                                        className="ant-table-row-cell-break-word"
                                                        hidden={!this.state.hasConversionRate}
                                                    >
                                                        {
                                                            this.state.taxPercentange > 0
                                                                ? (() => {

                                                                    const commission =
                                                                        invoice.commissionTypeFrom === 'Percentage'
                                                                            ? (
                                                                                parseFloat(invoice.commissionFromCourse || 0) *
                                                                                parseFloat(invoice.tutionFee || 0) / 100
                                                                            )
                                                                            : parseFloat(invoice.commissionFromCourse || 0);

                                                                    const total =
                                                                        commission *
                                                                        parseFloat(invoice.conversionRate || 0);

                                                                    if (this.state.taxPaidBy === "Company") {

                                                                        return (
                                                                            total *
                                                                            this.state.taxPercentange /
                                                                            (this.state.taxPercentange + 100)
                                                                        ).toFixed(2);

                                                                    } else if (this.state.taxPaidBy === "University") {
                                                                        return (
                                                                            total *
                                                                            this.state.taxPercentange / 100
                                                                        ).toFixed(2);
                                                                    }
                                                                })()
                                                                : '0.00'
                                                        }
                                                    </td>
                                                    {/* <td className="ant-table-row-cell-break-word" hidden={!this.state.hasConversionRate}>
                                                        {
                                                            this.state.taxPercentange > 0
                                                                ? invoice.commissionTypeFrom === 'Percentage'
                                                                    ? (
                                                                        (
                                                                            (
                                                                                parseFloat(invoice.commissionFromCourse || 0) *
                                                                                parseFloat(invoice.tutionFee || 0) / 100
                                                                            ) *
                                                                            parseFloat(invoice.conversionRate || 0) *
                                                                            this.state.taxPercentange /
                                                                            (this.state.taxPercentange + 100)
                                                                        ).toFixed(2)
                                                                    )
                                                                    : (
                                                                        (
                                                                            parseFloat(invoice.commissionFromCourse || 0) *
                                                                            parseFloat(invoice.conversionRate || 0) *
                                                                            this.state.taxPercentange /
                                                                            (this.state.taxPercentange + 100)
                                                                        ).toFixed(2)
                                                                    )
                                                                : '0.00'
                                                        }
                                                    </td> */}

                                                    <td className='ant-table-row-cell-break-word' hidden={this.state.hasConversionRate ? false : true}>
                                                        <Input
                                                            type='text'
                                                            value={invoice.adjustmentAmount ? invoice.adjustmentAmount : ""}
                                                            onChange={(e) => {
                                                                generatedInvoice.invoices[index].adjustmentAmount = e.target.value;
                                                                this.setState({ generatedInvoice });
                                                            }}
                                                        />
                                                    </td>
                                                    {/* <td className="ant-table-row-cell-break-word" hidden={!this.state.hasConversionRate}>
                                                        {
                                                            (() => {
                                                                const commissionFromCourse = parseFloat(invoice.commissionFromCourse || 0);
                                                                const tutionFee = parseFloat(invoice.tutionFee || 0);
                                                                const conversionRate = parseFloat(invoice.conversionRate || 0);
                                                                const adjustmentAmount = parseFloat(invoice.adjustmentAmount || 0);
                                                                const taxPercent = parseFloat(this.state.taxPercentange || 0);
                                                                const taxPaidBy = this.state.taxPaidBy;

                                                                let total = 0;

                                                                // Step 1: Calculate commission base amount
                                                                if (invoice.commissionTypeFrom === 'Percentage') {
                                                                    total = (commissionFromCourse * tutionFee / 100) * conversionRate;
                                                                } else if (commissionFromCourse && conversionRate) {
                                                                    total = commissionFromCourse * conversionRate;
                                                                }

                                                                // Step 2: Deduct tax (to get pre-tax value)
                                                                const preTax = taxPercent > 0
                                                                    ? total * 100 / (100 + taxPercent)
                                                                    : total;

                                                                // Step 3: Get tax amount
                                                                const taxAmount = total - preTax;

                                                                // Step 4: Add tax amount back + adjustment
                                                                const finalAmount = preTax + taxAmount + adjustmentAmount;

                                                                return finalAmount.toFixed(2);
                                                            })()
                                                        }
                                                    </td> */}
                                                    {/* <td className="ant-table-row-cell-break-word" hidden={!this.state.additionalDeduction}>
                                                        {
                                                            (() => {

                                                                const commissionFromCourse =
                                                                    parseFloat(invoice.commissionFromCourse || 0);

                                                                const tutionFee =
                                                                    parseFloat(invoice.tutionFee || 0);

                                                                const conversionRate =
                                                                    parseFloat(invoice.conversionRate || 0);

                                                                const adjustmentAmount =
                                                                    parseFloat(invoice.adjustmentAmount || 0);

                                                                const taxPercent =
                                                                    parseFloat(this.state.taxPercentange || 0);



                                                                const taxPaidBy =
                                                                    this.state.taxPaidBy;
                                                                const additionalDeduction =
                                                                    parseFloat(this.state.additionalTaxPercentange || 0);

                                                                let total = 0;

                                                                // STEP 1: BASE COMMISSION
                                                                if (invoice.commissionTypeFrom === 'Percentage') {

                                                                    total =
                                                                        (commissionFromCourse * tutionFee / 100)
                                                                        * conversionRate;

                                                                } else if (commissionFromCourse && conversionRate) {

                                                                    total =
                                                                        commissionFromCourse * conversionRate;
                                                                }

                                                                let finalAmount = total;

                                                                // COMPANY => TAX ALREADY INCLUDED
                                                                if (
                                                                    taxPercent > 0 &&
                                                                    taxPaidBy === "Company"
                                                                ) {

                                                                    finalAmount =
                                                                        total + adjustmentAmount;

                                                                }

                                                                // UNIVERSITY => TAX EXTRA
                                                                else if (
                                                                    taxPercent > 0 &&
                                                                    taxPaidBy === "University"
                                                                ) {

                                                                    const taxAmount =
                                                                        (total * taxPercent) / 100;

                                                                    finalAmount =
                                                                        total + taxAmount + adjustmentAmount;

                                                                }

                                                                // NO TAX
                                                                else {

                                                                    finalAmount =
                                                                        total + adjustmentAmount;
                                                                }

                                                                let deductionAmount = 0;

                                                                if (additionalDeduction < 0) {

                                                                    deductionAmount =
                                                                        (finalAmount * Math.abs(additionalDeduction)) / 100;

                                                                    finalAmount =
                                                                        finalAmount - deductionAmount;
                                                                }

                                                                return deductionAmount.toFixed(2);

                                                            })()
                                                        }
                                                    </td> */}
                                                    <td
                                                        className="ant-table-row-cell-break-word"
                                                        hidden={!this.state.hasConversionRate}
                                                    >
                                                        {
                                                            (() => {

                                                                const commissionFromCourse =
                                                                    parseFloat(invoice.commissionFromCourse || 0);

                                                                const tutionFee =
                                                                    parseFloat(invoice.tutionFee || 0);

                                                                const conversionRate =
                                                                    parseFloat(invoice.conversionRate || 0);

                                                                const adjustmentAmount =
                                                                    parseFloat(invoice.adjustmentAmount || 0);

                                                                const taxPercent =
                                                                    parseFloat(this.state.taxPercentange || 0);

                                                                const taxPaidBy =
                                                                    this.state.taxPaidBy;


                                                                let total = 0;

                                                                // STEP 1: BASE COMMISSION
                                                                if (invoice.commissionTypeFrom === 'Percentage') {

                                                                    total =
                                                                        (commissionFromCourse * tutionFee / 100)
                                                                        * conversionRate;

                                                                } else if (commissionFromCourse && conversionRate) {

                                                                    total =
                                                                        commissionFromCourse * conversionRate;
                                                                }

                                                                let finalAmount = total;

                                                                // COMPANY => TAX ALREADY INCLUDED
                                                                if (
                                                                    taxPercent > 0 &&
                                                                    taxPaidBy === "Company"
                                                                ) {

                                                                    finalAmount =
                                                                        total + adjustmentAmount;

                                                                }

                                                                // UNIVERSITY => TAX EXTRA
                                                                else if (
                                                                    taxPercent > 0 &&
                                                                    taxPaidBy === "University"
                                                                ) {

                                                                    const taxAmount =
                                                                        (total * taxPercent) / 100;

                                                                    finalAmount =
                                                                        total + taxAmount + adjustmentAmount;

                                                                }

                                                                // NO TAX
                                                                else {

                                                                    finalAmount =
                                                                        total + adjustmentAmount;
                                                                }

                                                                return finalAmount.toFixed(2);

                                                            })()
                                                        }
                                                    </td>

                                                    <td>
                                                        <RightsWrapper myRight={"financeInvoices.delete"}>
                                                            <Button onClick={() => this.removeUserFromInvoice(invoice)} shape='circle' size='small' icon='delete' />
                                                        </RightsWrapper>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Card>
                <Card>
                    {/* Invoice Number */}
                    <Col span={24}>
                        <label><b>Invoice Number</b></label>
                        <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                            <Col span={4}>
                                <Button className={!showInvoiceNumber ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceNumber: false }) }}>Auto Generate</Button>
                            </Col>
                            <Col span={5}>
                                <Button className={showInvoiceNumber ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceNumber: true }) }}>Manually Generate</Button>
                            </Col>
                        </Row>
                        {
                            showInvoiceNumber ?
                                <Input
                                    type={'text'}
                                    name="invoiceNumber"
                                    style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                    placeholder="Invoice Number"
                                    value={generatedInvoice.invoiceNumber}
                                    onChange={(e) => {
                                        generatedInvoice.invoiceNumber = e.target.value
                                        this.setState({ generatedInvoice })
                                    }}
                                />
                                : null
                        }

                    </Col>
                    {/* Invoice Date */}
                    <Col span={24}>
                        <label><b>Invoice Date</b></label>
                        <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                            <Col span={4}>
                                <Button className={!showInvoiceDate ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceDate: false }) }}>Auto Select</Button>
                            </Col>
                            <Col span={5}>
                                <Button className={showInvoiceDate ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceDate: true }) }}>Manually Select</Button>
                            </Col>
                        </Row>
                        {
                            showInvoiceDate ?
                                <Input
                                    type={'date'}
                                    style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                    name="invoiceGeneratedDate"
                                    placeholder="Invoice Date"
                                    value={invoiceReceivingDate}
                                    onChange={(e) => {
                                        generatedInvoice.invoiceGeneratedDate = e.target.value
                                        this.setState({ generatedInvoice })
                                    }}
                                />
                                : null
                        }
                    </Col>
                    {/* Bank Account */}
                    <Col span={24}>
                        <Row>
                            <Col span={8}>
                                <select
                                    name='companyBankId'
                                    value={generatedInvoice.companyBankId}
                                    style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                    className='form-control'
                                    onChange={(e) => {
                                        generatedInvoice.companyBankId = e.target.value
                                        this.setState({ generatedInvoice })
                                    }}
                                >
                                    <option value="">Choose Bank Details</option>
                                    {
                                        companyDetails && companyDetails.length ?
                                            companyDetails.map((item, index) => {
                                                return (<option value={item._id} key={index}>{item.companyName}</option>)
                                            })
                                            : null
                                    }
                                </select>
                            </Col>
                        </Row>
                    </Col>
                    {/* Tax Details */}
                    <Col span={24}>
                        <select
                            name='taxPaidBy'
                            value={generatedInvoice.taxPaidBy}
                            style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                            className='form-control'
                            onChange={(e) => {
                                generatedInvoice.taxPaidBy = e.target.value
                                this.setState({ generatedInvoice, taxPaidBy: e.target.value })
                            }}
                        >
                            <option value="">Choose Tax Paid By</option>
                            <option value="Company">Company</option>
                            <option value="University">University</option>
                        </select>
                    </Col>
                    {
                        generatedInvoice.taxPaidBy ?
                            <Col span={24}>
                                <Row>
                                    <Col span={8}>
                                        <select
                                            name='taxTypeId'
                                            value={generatedInvoice.taxTypeId}
                                            style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                            className='form-control'
                                            onChange={(e) => this.updateCpTax(e.target.value)}
                                        // onChange={(e) => {
                                        //     generatedInvoice.taxTypeId = e.target.value
                                        //     this.setState({ generatedInvoice })
                                        // }}
                                        >
                                            <option value="">Choose Tax</option>
                                            {
                                                allTaxes && allTaxes.length ?
                                                    allTaxes.map((item, index) => {
                                                        return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                    })
                                                    : null
                                            }
                                        </select>
                                    </Col>
                                </Row>
                            </Col>
                            : null
                    }

                    <Col span={24}>
                        <Checkbox
                            checked={this.state.hasConversionRate}
                            onChange={(y) => {
                                const checked = y.target.checked;

                                this.setState({ hasConversionRate: checked }, () => {
                                    if (checked && this.tableScrollRef.current) {
                                        this.tableScrollRef.current.scrollTo({
                                            left: this.tableScrollRef.current.scrollWidth,
                                            behavior: 'smooth'
                                        });
                                    }
                                });
                            }}
                        >
                            <Popover placement="bottomLeft" content={content}>
                                <span
                                    style={{
                                        color: "#1890FF",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        marginLeft: 4
                                    }}
                                >
                                    Add Exchange Rate{" "} !
                                </span>
                            </Popover>
                        </Checkbox>

                    </Col>
                    {
                        this.state.hasConversionRate ?
                            <Col span={24} style={{ marginTop: 10 }}>
                                <Checkbox
                                    checked={this.state.additionalDeduction}
                                    onChange={(y) => {
                                        const checked = y.target.checked;

                                        this.setState({ additionalDeduction: checked }, () => {
                                            if (checked && this.tableScrollRef.current) {
                                                this.tableScrollRef.current.scrollTo({
                                                    left: this.tableScrollRef.current.scrollWidth,
                                                    behavior: 'smooth'
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <Popover placement="bottomLeft" content={content}>
                                        <span
                                            style={{
                                                color: "#1890FF",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                marginLeft: 4
                                            }}
                                        >
                                            Any Additional Tax{" "} !
                                        </span>
                                    </Popover>
                                </Checkbox>

                            </Col>
                            : null
                    }
                    {
                        this.state.additionalDeduction ?
                            <Col span={24} style={{ marginTop: 10 }}>
                                <Row>
                                    <Col span={8}>
                                        <select
                                            name='taxTypeId'
                                            value={generatedInvoice.additionalTaxTypeId}
                                            style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                            className='form-control'
                                            onChange={(e) => this.updateAdditionalCpTax(e.target.value)}
                                        // onChange={(e) => {
                                        //     generatedInvoice.taxTypeId = e.target.value
                                        //     this.setState({ generatedInvoice })
                                        // }}
                                        >
                                            <option value="">Choose Additional Tax</option>
                                            {
                                                allTaxes && allTaxes.length ?
                                                    allTaxes.map((item, index) => {
                                                        return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                    })
                                                    : null
                                            }
                                        </select>
                                    </Col>
                                </Row>
                            </Col>

                            : null
                    }
                    {
                        this.state.hasConversionRate ?
                            <Col span={24} style={{ marginTop: 10 }}>
                                <Checkbox
                                    checked={this.state.hasBankCharges}
                                    onChange={(y) => {
                                        const checked = y.target.checked;

                                        this.setState({ hasBankCharges: checked }, () => {
                                            if (checked && this.tableScrollRef.current) {
                                                this.tableScrollRef.current.scrollTo({
                                                    left: this.tableScrollRef.current.scrollWidth,
                                                    behavior: 'smooth'
                                                });
                                            }
                                        });
                                    }}
                                >
                                    <Popover placement="bottomLeft" content={content}>
                                        <span
                                            style={{
                                                color: "#1890FF",
                                                fontWeight: "bold",
                                                cursor: "pointer",
                                                marginLeft: 4
                                            }}
                                        >
                                            Any Bank Charges{" "} !
                                        </span>
                                    </Popover>
                                </Checkbox>

                            </Col>
                            : null
                    }
                    {
                        this.state.hasBankCharges ?
                            <Col span={24} style={{ marginTop: 10 }}>
                                <Row>
                                    <Col span={8}>
                                        <Input
                                            type={'text'}
                                            name="bankCharges"
                                            style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                            placeholder={`Bank Charges ${companyCurrency}`}
                                            value={generatedInvoice.bankCharges}
                                            onChange={(e) => {
                                                generatedInvoice.bankCharges = e.target.value
                                                this.setState({ generatedInvoice })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>

                            : null
                    }
                    <Col span={24} style={{ marginTop: 10 }}>

                        <Button
                            type="primary"
                            loading={enableBTN}
                            disabled={enableBTN}
                            onClick={() => this.doSubmitCompanyBankId()}> Generate
                        </Button>
                    </Col>
                </Card>
            </Drawer>
        )
    }
}


const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupedPerformaInvoice)